import { useEffect, useRef } from 'react'

import PropTypes from 'prop-types'

const useInfiniteScroll = ({ onIntersect, enabled = true } = {}) => {
    const sentinelRef = useRef(null)

    useEffect(() => {
        if (!enabled || !sentinelRef.current)
            return

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                onIntersect()
            }
        }, { rootMargin: '400px' })

        observer.observe(sentinelRef.current)

        return () => observer.disconnect()
    }, [enabled, onIntersect])

    return { sentinelRef }
}

useInfiniteScroll.propTypes = {
    onIntersect: PropTypes.func.isRequired,
    enabled: PropTypes.bool
}

export { useInfiniteScroll }
